<template>

    <div>
        <ProtocolList/>
    </div>

</template>

<script>

    import ProtocolList from './protocol/ProtocolList.vue'

    export default {
        name: "Protocol",

        props: {},

        components: {
            ProtocolList
        },

        data: () => ({}),

        methods: {}
    };
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Protocol.vue